module.exports = __webpack_public_path__ + "img/icon-white-5.964f7fda.svg";